import React, { useMemo } from 'react';
import { useOntologyViewsIndex } from '../views/hooks/useOntologyViews';
import { viewBranchPreviewPath } from '../sandbox/utils/previewDestination';
import { useProcessTeam } from '../workforce/useProcessTeam';
import ViewAsButton from './ViewAsButton';
import { useViewAs } from './ViewAsContext';

/** Each role that will see an app this draft changes, and the first such app. */
export function rolesSeeingChangedApps(views = [], roles = []) {
  const bySlug = new Map(roles.map((role) => [role.slug, role]));
  const seen = new Map();
  views.filter((view) => view.is_sandbox_revision && view.is_published !== false).forEach((view) => {
    (view.visible_to_roles || []).forEach((slug) => {
      const role = bySlug.get(slug);
      if (role && !seen.has(role.id)) seen.set(role.id, { role, view });
    });
  });
  return [...seen.values()];
}

/** On a draft's publication card: see the new screens as the people who will use them. */
export default function PreviewAsRoles({ approval, className = '' }) {
  const enabled = Boolean(useViewAs()?.canViewAs && approval?.scope?.sandbox_id);
  const sandboxContext = useMemo(() => (enabled
    ? { sandbox_id: approval.scope.sandbox_id, active_overlay_id: approval.scope.overlay_id || undefined }
    : null), [enabled, approval?.scope?.sandbox_id, approval?.scope?.overlay_id]);
  const { data: views = [] } = useOntologyViewsIndex({ enabled, sandboxContext });
  const team = useProcessTeam(enabled);
  const previews = rolesSeeingChangedApps(views, team.data?.roles || []);
  if (!enabled || !previews.length) return null;
  const context = { sandboxId: approval.scope.sandbox_id, revisionId: approval.scope.overlay_id, approvalId: approval.id };
  return <div className={`flex flex-wrap gap-2 ${className}`} data-testid="preview-as-roles">
    {previews.map(({ role, view }) => (
      <ViewAsButton key={role.id} target={`role:${role.id}`} path={viewBranchPreviewPath(view, context) || '/app/home'}
        className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:border-cyan-300 hover:bg-cyan-50">
        Preview as {role.name}
      </ViewAsButton>
    ))}
  </div>;
}
